import React from "react";
import { DeviceSelector, ErrorDisplay, PermissionRequest } from "../camera/CameraControls.tsx";
import StockOverlay from "./StockOverlay.tsx";
import ScannedItemDisplay from "./ScannedItemDisplay.tsx";
import BarcodeNotFound from "./BarcodeNotFound.tsx";
import UndoButton from "./UndoButton.tsx";
import { ProductItemWithDetails } from "utils/grocyApi.ts";
import "./ConsumeFeedUI.css";

interface ConsumeFeedUIProps {
  consumptionMode: 'scanning' | 'consuming';
  scannedProduct: {
    productItem: ProductItemWithDetails;
    barcode: string;
  } | null;
  barcodeNotFound: string | null;
  scanResultState: 'found' | 'no-stock' | 'not-found' | null;
  showStockOverlay: boolean;
  barcode: string;
  onClearScan: () => void;
  onToggleStockOverlay: () => void;
  onOpenManualPicker: () => void;
}

const ConsumeFeedUI: React.FC<ConsumeFeedUIProps> = ({
  consumptionMode,
  scannedProduct,
  barcodeNotFound,
  scanResultState,
  showStockOverlay,
  barcode,
  onClearScan,
  onToggleStockOverlay,
  onOpenManualPicker,
}) => {
  return (
    <div className="camera-feed__overlays">
      {/* Show scanned item display or barcode not found in consumption mode */}
      {consumptionMode === 'consuming' ? (
        <>
          {scannedProduct ? (
            <ScannedItemDisplay
              productItem={scannedProduct.productItem}
              barcode={scannedProduct.barcode}
              status={scanResultState === 'no-stock' ? 'no-stock' : 'ready'}
              onClear={onClearScan}
              className="camera-feed__scanned-item"
            />
          ) : barcodeNotFound ? (
            <BarcodeNotFound
              barcode={barcodeNotFound}
              onClear={onClearScan}
              className="camera-feed__barcode-not-found"
            />
          ) : null}
        </>
      ) : (
        /* Show stock overlay in scanning mode */
        showStockOverlay ? <StockOverlay onHide={onToggleStockOverlay} /> : null
      )}
      
      <ErrorDisplay className="camera-feed__error" />
      
      {/* Show simple barcode display only in scanning mode */}
      {consumptionMode === 'scanning' && barcode && (
        <div className="camera-feed__barcode-row">
          <span>Barcode: {barcode}</span>
        </div>
      )}
      
      <div className="camera-feed__bottom-controls">
        <div className="camera-feed__bottom-left">
          <PermissionRequest className="camera-overlay" />
          <DeviceSelector className="camera-overlay" fullscreen />
        </div>
        <div className="camera-feed__bottom-center">
          <button
            type="button"
            onClick={onOpenManualPicker}
            className="camera-feed__pick-product-button"
          >
            Pick Product
          </button>
        </div>
        <div className="camera-feed__bottom-right">
          <UndoButton className="camera-feed__undo-footer" />
        </div>
      </div>
    </div>
  );
};

export default ConsumeFeedUI; 
